import { render, staticRenderFns } from "./EmailResetPasswordForm.vue?vue&type=template&id=656c8d60"
import script from "./EmailResetPasswordForm.vue?vue&type=script&lang=js"
export * from "./EmailResetPasswordForm.vue?vue&type=script&lang=js"
import style0 from "./fade.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports